import React from "react";

import Hero from "../../components/hero";
import Layout from "../../components/Layout/Page";
import {
  Container,
  Heading,
  Image,
  TEXT,
  ImageContainer,
  LogoContainer,
  LogoContainer1,
  CardContainer,
  ContactDetails,
  ContactInfo,
  Icon,
  InnerBackgroundContainer,
  MainContainer,
  Name,
  TitleContainer,
  WriteUSCard,
  InnerLeftContainer,
  Heading2,
  BottomContanier,
  Line,
  Label,
  Text,
  HorizontalLine,
  InnerRightContainer,
  Button,
} from "./styled.components";
import jubilee from "../../assets/images/jubilee.png";
import adamjee from "../../assets/images/adamjee.png";
import jsbank from "../../assets/images/jsbank.png";
import soneri from "../../assets/images/soneri.png";
import ALFALAHLOGO from "../../assets/images/alfalah.png";
import UBLLOGO from "../../assets/images/ubl.png";
import MCBLOGO from "../../assets/images/mcb.png";
import STANDARDCHARTEDLOGO from "../../assets/images/standardCharted.png";
import HABIBBANKLOGO from "../../assets/images/habibbank.png";
import ALLIEDBANKLOGO from "../../assets/images/alliedbank.png";

import STATELIFELOGO from "../../assets/images/stateLifeLogo.png";
import PGILOGO from "../../assets/images/pgi.jpg";

const Bank = () => {
  return (
    <>
      <Layout>
        <Hero
          title="Bank & Insurances"
          SubTitle="Explore our comprehensive Bank & Insurances services, designed to safeguard your construction projects and investments"
        />
        <Container>
          <Heading>3H Banks</Heading>

          <TEXT>
            We have bank accounts in well-established financial institutions
            across the country to ensure easy access to banking services,
            streamlined transactions, and reliable financial support, all of
            which are crucial for the smooth functioning and execution of the
            project
          </TEXT>
        </Container>
        <ImageContainer className="row">
          <LogoContainer className="col-md-3 col-sm-6 col-xs-12">
            <Image src={jsbank}></Image>
          </LogoContainer>
          <LogoContainer1 className="col-md-3 col-sm-6 col-xs-12">
            <Image src={soneri}></Image>
          </LogoContainer1>
          <LogoContainer className="col-md-3 col-sm-6 col-xs-12">
            <Image src={ALFALAHLOGO}></Image>
          </LogoContainer>
          <LogoContainer1 className="col-md-3 col-sm-6 col-xs-12">
            <Image src={UBLLOGO}></Image>
          </LogoContainer1>
        </ImageContainer>
        <ImageContainer className="row">
          <LogoContainer className="col-md-3 col-sm-6 col-xs-12">
            <Image src={MCBLOGO}></Image>
          </LogoContainer>
          <LogoContainer1 className="col-md-3 col-sm-6 col-xs-12">
            <Image src={STANDARDCHARTEDLOGO}></Image>
          </LogoContainer1>
          <LogoContainer className="col-md-3 col-sm-6 col-xs-12">
            <Image src={HABIBBANKLOGO}></Image>
          </LogoContainer>
          <LogoContainer1 className="col-md-3 col-sm-6 col-xs-12">
            <Image src={ALLIEDBANKLOGO}></Image>
          </LogoContainer1>
        </ImageContainer>
        <Container>
          <Heading>3H Insurance Company</Heading>

          <TEXT>
            Our comprehensive insurance solutions from esteemed insurance
            companies nationwide, provide employees and the company alike with
            protection, peace of mind, and a secure foundation for success
          </TEXT>
        </Container>
        <ImageContainer className="row">
          <LogoContainer className="col-md-3 col-sm-6 col-xs-12">
            <Image src={jubilee}></Image>
          </LogoContainer>
          <LogoContainer1 className="col-md-3 col-sm-6 col-xs-12">
            <Image src={adamjee}></Image>
          </LogoContainer1>
          <LogoContainer className="col-md-3 col-sm-6 col-xs-12">
            <Image src={STATELIFELOGO}></Image>
          </LogoContainer>
          <LogoContainer1 className="col-md-3 col-sm-6 col-xs-12">
            <Image src={PGILOGO}></Image>
          </LogoContainer1>
        </ImageContainer>
        <InnerBackgroundContainer>
          <CardContainer className="col-md-10 col-11 mx-auto">
            <ContactDetails className="row d-flex flex-wrap">
              <h3 className="col-12"> Legal Advisory & Consultant</h3>
              <TitleContainer className="col-sm-6">
                <Name>Mr Muhammad Essa Khan (Gilgit)</Name>
                <ContactInfo>(051) - 54678391</ContactInfo>
              </TitleContainer>
              <TitleContainer className="col-sm-6">
                <Name>Mr Syed Muhammad Ali Shah (Baltistan)</Name>
                <ContactInfo>(051) - 54678391</ContactInfo>
              </TitleContainer>
              <TitleContainer className="col-sm-6">
                <Name>Mr Ishfaq Hussain Naqvi</Name>
                <ContactInfo>(051) - 54678391</ContactInfo>
              </TitleContainer>
              <TitleContainer className="col-sm-6">
                <Name>Advocate High Court,Hayat & Marjees</Name>
                <ContactInfo>(051) - 54678391</ContactInfo>
              </TitleContainer>
            </ContactDetails>
          </CardContainer>
        </InnerBackgroundContainer>
      </Layout>
    </>
  );
};

export default Bank;
